module.exports = __webpack_public_path__ + "img/20200907_094750.64503ae8.jpg";